import type { TrackingFn } from '@change-corgi/core-react/tracking';

import type { AttachedPost } from './attachedPost';
import { linkAddedProperties, toAttachedPost } from './attachedPost';
import type { SocialPostErrorCode } from './errorCodes';
import { classifySocialPostInput } from './utils';
import type { ClassifyOptions } from './utils';

type PastedInputContext = {
	classifyOptions: ClassifyOptions;
	track: TrackingFn;
	setAttachedPost: (post: AttachedPost) => void;
	setBlockError: (code: SocialPostErrorCode | undefined) => void;
	/** Clears a failed freeform submit, whose error banner would otherwise stay attached to the new chip. */
	resetIssueDraftError: () => void;
};

/**
 * A pasted link is tracked whatever its outcome. A supported one attaches and starts its preview;
 * a blocked one lands in the box and surfaces its error straight away. Freeform text is left alone.
 */
export function handlePastedInput(text: string, ctx: PastedInputContext): void {
	const classification = classifySocialPostInput(text, ctx.classifyOptions);
	if (classification.kind === 'freeform') return;

	void ctx.track('homepage_social_post_link_added', linkAddedProperties(classification, text.trim(), 'paste'));

	if (classification.kind === 'supported_link') {
		// The URL lands in the textarea as usual, with a resolving indicator below it (see
		// isResolvingPreview), until the preview succeeds and the chip replaces the textarea.
		ctx.setBlockError(undefined);
		ctx.resetIssueDraftError();
		ctx.setAttachedPost(toAttachedPost(classification));
		return;
	}

	ctx.setBlockError(classification.kind);
}
